<template>
	<div
		class="--axis --axis-x"
		:style="{ width: `${width}px` }"
	>
		<span
			v-for="item in items"
			:key="item.value"
			class="--axis-x-item"
			:class="{ '--zero': item.positionX < 0.1 }"
			:style="{ left: `${item.positionX}px` }"
		>
			{{ item.label }}
		</span>
	</div>
</template>

<script>
const itemWidth = 51
const minItemInterval = 60
const spanList = [0.01, 0.02, 0.05, 0.1, 0.2, 0.5, 1, 2, 3, 5, 7.5, 10, 15, 30, 60]

/**
 * @typedef {Object} AxisXItem
 * @property {number} value
 * @property {string} label
 * @property {number} positionX
 */

export default {
	name: 'AxisX',
	props: {
		width: {
			type: Number,
			default: 256
		},
		min: {
			type: Number,
			default: 0
		},
		max: {
			type: Number,
			default: 5
		}
	},
	computed: {
		/**
		 * @returns {AxisItem[]}
		 */
		items () {
			const items = []
			const maxDivs = Math.floor(this.width / minItemInterval)
			const minSpan = (this.max - this.min) / maxDivs
			const span = spanList.find(s => s >= minSpan)
			if (!span) return items
			const divs = (this.max - this.min) / span
			const fractionDigits = Math.max(0, -Math.floor(Math.log10(span)))
			for (let i = 0; i < divs; i++) {
				const value = this.min + span * i
				const positionX = Math.round(this.width * i / divs) - Math.floor(itemWidth / 2)
				items.push({
					value,
					label: this.format(value, fractionDigits),
					positionX: Math.max(0, positionX)
				})
			}
			return items
		}
	},
	methods: {
		/**
		 * 数値をラベル表示値に変換する
		 * @param {number} number 数値 [秒]
		 * @param {number} fractionDigits 小数点以下の桁数
		 * @returns {string}
		 */
		format (number, fractionDigits = 0) {
			if (number < 0.001) {
				return '0'
			}
			let n = number
			const parts = []
			if (number >= 3600) {
				const hour = Math.floor(n / 3600)
				parts.push(String(hour % 24) + ':')
				n = n % 3600
			}
			if (number >= 60) {
				parts.push(String(Math.floor(n / 60)).padStart(2, '0') + ':')
				n = n % 60
			}
			parts.push(String(Math.floor(n)).padStart(2, '0'))
			n = n % 1
			if (fractionDigits > 0) {
				parts.push('.' + (String(n).replace(/^0[.]/, '') + '0'.repeat(fractionDigits)).substring(0, fractionDigits))
			}
			return parts.join('').replace(/^0+/, '').replace(/^[.]/, '0.').replace(/^:/, '0:')
		}
	}
}
</script>

<style lang="scss" scoped>
.--axis-x {
	position: relative;
	height: 18px;
}

.--axis-x-item {
	position: absolute;
	display: block;
	left: 0;
	right: 0;
	width: 51px;
	padding-top: 5px;
	font-size: 10px;
	line-height: 1;
	text-align: center;

	&::after {
		content: "";
		display: block;
		position: absolute;
		top: 0;
		left: 25px;
		width: 1px;
		height: 3px;
		background: #777;
	}

	&.--zero {
		text-align: left;

		&::after {
			left: 0;
		}
	}
}
</style>
